<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on }">
      <v-tooltip bottom color="success">
        <template v-slot:activator="{ tooltip }">
          <v-chip
            dark
            label
            class="mr-1 caption"
            color="success"
            small
            v-show="getSaleEstimateData !== undefined"
            v-on="{ ...on, ...tooltip }"
            >{{
              getSaleEstimateData ? getSaleEstimateData.value : ""
            }}
            $</v-chip
          >
        </template>
        Estimation
      </v-tooltip>
      <v-btn
        small
        icon
        color="success"
        v-on="on"
        v-show="getSaleEstimateData === undefined"
      >
        <v-icon small>fa-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <v-form @submit.prevent="save">
          <v-row no-gutters>
            <j-decimal-input
              ref="estimateInput"
              filled
              dense
              class="no-before"
              hide-details
              label="Estimation"
              :disabled="loading"
              :value="value ? value : null"
              suffix="$"
              @input="v => (newValue = v)"
            ></j-decimal-input>
          </v-row>
          <v-row no-gutters>
            <v-btn block color="success" :disabled="loading" type="submit">
              <v-icon left small>fa-save</v-icon>
              Enregistrer
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "EventCalendarEstimateAdder",
  props: {
    date: {
      required: true
    },
    value: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getSalesEstimates", "getStoreId"]),
    getSaleEstimateData() {
      const e = this.getSalesEstimates.find(x => x.date === this.date);
      return e;
    }
  },
  data() {
    return {
      loading: false,
      menu: false,
      newValue: null
    };
  },
  methods: {
    async save() {
      if (this.loading !== true) {
        try {
          this.loading = true;
          if (this.getSaleEstimateData !== undefined) {
            const d = {
              ...this.getSaleEstimateData,
              value: this.newValue
            };
            await this.$store.dispatch("updateSaleEstimate", d);
          } else {
            const d = {
              date: this.date,
              store: this.getStoreId,
              value: this.newValue
            };
            await this.$store.dispatch("addSaleEstimate", d);
          }
          this.$emit("update");
          this.menu = false;
        } finally {
          this.loading = false;
        }
      }
    }
  },
  watch: {
    menu(v) {
      if (v === false) {
        this.newValue = null;
      } else {
        setTimeout(() => this.$refs.estimateInput.focus(), 100);
      }
    }
  }
};
</script>

<style></style>
